//create side bar item route and export from here.
// import dashboard from './dashboard';
// import about from './about';
// import failedLeads from './FailedLeads';
// import successfulLeads from './SuccessfulLeads';
// import csvUpload from './CsvUpload';
// import user from './User';
// import addLeads from './AddLeads';
// import cron from './Cron';
// import logs from './logs';
// import leadEditLogs from './LeadEditLogs';
// import leadLogs from './leadLogs';
// import junkLeads from './JunkLeads';
// import country from './Country'
import offerUserList from './offerUserList'

export const sideBarItems = [
    // dashboard,
    // successfulLeads,
    // failedLeads,
    // csvUpload,
    // addLeads,
    // user,
    // cron,
    // logs,
    // country,
    // leadEditLogs,
    // leadLogs,
    // junkLeads,
    offerUserList
];


// WEBPACK FOOTER //
// ./src/sidebar/index.js